
export const integrationTypes = {
  apricot: 'apricot',
  eto: 'eto-impact'
}



// WEBPACK FOOTER //
// src/tenantInfo/integration-types.js